import { Routes, Route } from "react-router-dom";
import { App as AntApp } from "antd";
import { PrivateRoute, AdminRoute } from "./components";
import {
  Login,
  Referee,
  Referees,
  Home,
  Competitions,
  Teams,
  Archers,
  Competition,
  Team,
  Archer,
  Ranks,
  Rank,
  News,
  NewsDetail,
  AddNews,
  Leaders,
  Leader,
  Ranking,
  Erembe,
  Privacy,
  AuditLogs,
  Admins,
  AppVersions
} from "./pages";
import { ArcherImport } from "./pages/Archers";

function App() {
  return (
    <AntApp>
      <Routes>
      <Route key="login" path="login" element={<Login />} />
      <Route key="privacy" path="privacy-policy" element={<Privacy />} />

      <Route
        key="home"
        path="/"
        element={
          <PrivateRoute>
            <Home />
          </PrivateRoute>
        }
      />

      <Route
        key="addNews"
        path="add-news"
        element={
          <PrivateRoute>
            <AddNews />
          </PrivateRoute>
        }
      />
      <Route
        key="news"
        path="news"
        element={
          <PrivateRoute>
            <News />
          </PrivateRoute>
        }
      />

      <Route
        key="newsDetail"
        path="news/:newsId"
        element={
          <PrivateRoute>
            <NewsDetail />
          </PrivateRoute>
        }
      />

      <Route
        key="ranks"
        path="ranks"
        element={
          <PrivateRoute>
            <Ranks />
          </PrivateRoute>
        }
      />

      <Route
        key="rank"
        path="ranks/:rankId"
        element={
          <PrivateRoute>
            <Rank />
          </PrivateRoute>
        }
      />

      <Route
        key="teams"
        path="teams"
        element={
          <PrivateRoute>
            <Teams />
          </PrivateRoute>
        }
      />

      <Route
        key="team"
        path="teams/:teamId"
        element={
          <PrivateRoute>
            <Team />
          </PrivateRoute>
        }
      />

      <Route
        key="competitions"
        path="competitions"
        element={
          <PrivateRoute>
            <Competitions />
          </PrivateRoute>
        }
      />

      <Route
        key="competition"
        path="competitions/:competitionId"
        element={
          <PrivateRoute>
            <Competition />
          </PrivateRoute>
        }
      />

      <Route
        key="archers"
        path="archers"
        element={
          <PrivateRoute>
            <Archers />
          </PrivateRoute>
        }
      />

      <Route
        key="archerImport"
        path="archers/import"
        element={
          <PrivateRoute>
            <ArcherImport />
          </PrivateRoute>
        }
      />

      <Route
        key="archer"
        path="archers/:archerId"
        element={
          <PrivateRoute>
            <Archer />
          </PrivateRoute>
        }
      />

      <Route
        key="referees"
        path="referees"
        element={
          <PrivateRoute>
            <Referees />
          </PrivateRoute>
        }
      />

      <Route
        key="referee"
        path="referees/:refereeId"
        element={
          <PrivateRoute>
            <Referee />
          </PrivateRoute>
        }
      />
      <Route
        key="leaders"
        path="leaders"
        element={
          <PrivateRoute>
            <Leaders />
          </PrivateRoute>
        }
      />

      <Route
        key="leader"
        path="leaders/:leaderId"
        element={
          <PrivateRoute>
            <Leader />
          </PrivateRoute>
        }
      />
      <Route
        key="rankings"
        path="rankings"
        element={
          <PrivateRoute>
            <Ranking />
          </PrivateRoute>
        }
      />
      <Route
        key="erembe"
        path="erembe"
        element={
          <PrivateRoute>
            <Erembe />
          </PrivateRoute>
        }
      />
      <Route
        key="audit-logs"
        path="audit-logs"
        element={
          <AdminRoute>
            <AuditLogs />
          </AdminRoute>
        }
      />
      <Route
        key="admins"
        path="admins"
        element={
          <PrivateRoute>
            <Admins />
          </PrivateRoute>
        }
      />
      <Route
        key="app-versions"
        path="app-versions"
        element={
          <PrivateRoute>
            <AppVersions />
          </PrivateRoute>
        }
      />
    </Routes>
    </AntApp>
  );
}

export default App;
